import React from 'react';
import { GRUPOS_ESTADOS } from '../shared/utils/estadosPedido';

const estadosFront = {
  pendiente: "Pendiente",
  confirmado: "Confirmado",
  listo: "Listo para entrega",
  en_proceso: "Preparando",
  en_ruta: "En ruta con delivery",
  cerrado_por_cliente: "Cerrado por cliente",
  cerrado: "Finalizado (Admin)",
  completado: "Finalizado (Delivery)",
  rechazado: "Rechazado"
};

const coloresBorde = [
  'border-primary', 'border-success', 'border-warning', 
  'border-danger', 'border-info', 'border-secondary'
];

function colorPorPedido(id) {
  if (!id) return 'border-secondary';
  const idStr = String(id);
  const hash = [...idStr].reduce((acc, char) => acc + char.charCodeAt(0), 0);
  return coloresBorde[hash % coloresBorde.length];
}

function getModoEntregaBadgeClass(modo) {
  switch ((modo || "").toLowerCase()) {
    case "retiro": return "badge bg-primary";
    case "delivery": return "badge bg-info";
    default: return "badge bg-secondary";
  }
}

export default function PedidosLista({
  pedidos,
  filtro,
  pedidoExpandidoId,
  setPedidoExpandidoId,
  onSeleccionar,
  onProcesarPedido,
  moverPedidoACompletados,
  onNotificarListoBridge
}) {
  return (
    <ul className="list-group">
    {pedidos.filter(p => !!p).map((pedido) => {
      // --- 1. Usamos el ID Normalizado (UUID largo) ---
      const pedidoId = pedido.id;

      // --- 2. NORMALIZACIÓN DE DATOS DE ENVÍO ---
      // Manejamos si viene como String (DB/Pusher viejo) o como Objeto (Pusher nuevo)
      let datosEnvio = {};
      try {
        datosEnvio = typeof pedido.envio === 'string' 
          ? JSON.parse(pedido.envio) 
          : (pedido.envio || {});
      } catch (e) {
        console.error("Error parseando envio:", e);
        datosEnvio = {};
      }

      // Extraemos el nombre del receptor (el que ingresa en la Opción 2 del bot)
      const nombreReceptor = datosEnvio.nombre_receptor || datosEnvio.nombre;

      // Lógica de cierre: Retiro se cierra manual, Delivery se cierra cuando llega
      const esPedidoCerrable =
        (pedido.modo_entrega === 'retiro' && pedido.estado === 'confirmado') ||
        (pedido.modo_entrega === 'delivery' && pedido.estado_bridge === 'ENTREGADO');

      return (
        <li
          key={pedidoId}
          className={`list-group-item bg-dark text-white border-start border-4 ${colorPorPedido(pedidoId)} mb-2 rounded`}
        >
          <div className="d-flex justify-content-between align-items-center">
            <span>
              {/* NOMBRE DE REGISTRO: Siempre fijo arriba */}
              <strong className="text-info">Cliente:</strong> {pedido.cliente_nombre || 'Sin nombre'}
              
              {/* ETIQUETA DE RECEPTOR: Solo si es delivery y el nombre es distinto al del cliente */}
              {pedido.modo_entrega === 'delivery' && nombreReceptor && nombreReceptor !== pedido.cliente_nombre && (
                <div className="small text-warning mt-1">
                  <i className="bi bi-person-badge"></i> <strong>Recibe:</strong> {nombreReceptor}
                </div>
              )}

              {(!pedido.admin_id && GRUPOS_ESTADOS.PENDIENTES.includes(pedido.estado)) && (
                <span className="badge bg-success ms-2">🆕 Nuevo</span>
              )}
              <br />
              <strong>Estado:</strong> {estadosFront[pedido.estado] || pedido.estado}<br />
              <strong>Fecha:</strong> {new Date(pedido.fecha).toLocaleString()}<br />

              <strong className="badge bg-warning text-dark ms-2">Entrega:</strong>{" "}
              <span className={getModoEntregaBadgeClass(pedido.modo_entrega)}>
                {pedido.modo_entrega === 'retiro' ? '🏪 Retiro' : '🛵 Delivery'}
              </span>
            </span>

              <div className="d-flex flex-column align-items-end gap-2">
                
                {/* BOTÓN PROCESAR: Solo en vista de pendientes */}
                {filtro === 'pendientes' && GRUPOS_ESTADOS.PENDIENTES.includes(pedido.estado) && (
                  <button
                    className="btn btn-sm btn-outline-danger"
                    disabled={!!pedido.admin_id}
                    onClick={() => {
                      onSeleccionar(pedido);
                      onProcesarPedido(pedido.pedido_id);
                    }}
                    
                  >
                    Procesar
                  </button>
                )}

                {/* --- SECCIÓN BRIDGE (LOGÍSTICA) --- */}
                {/* Restauramos la lógica: Si es delivery y estamos en la pestaña delivery */}
                {filtro === 'delivery' && pedido.modo_entrega === 'delivery' && (
                  <div className="d-flex flex-column gap-1 align-items-end">
                    
                 {/* BOTÓN LIBERADO: Se muestra siempre, excepto si el pedido ya fue entregado de verdad */}
{pedido.estado_bridge !== 'ENTREGADO' && (
  <button
    className="btn btn-sm btn-info text-white shadow-sm"
    onClick={() => onNotificarListoBridge(pedidoId)}
  >
    📦 Avisar Delivery (Listo)
  </button>
)}

                    {/* Badges de seguimiento en tiempo real */}
                    {pedido.estado_bridge === 'LISTO_PARA_RECOGER' && <span className="badge bg-warning text-dark animate-pulse">⏳ Esperando Repartidor</span>}
                    {pedido.estado_bridge === 'EN_CAMINO_A_TIENDA' && <span className="badge bg-primary">🚚 Repartidor en camino</span>}
                    {pedido.estado_bridge === 'EN_TIENDA' && <span className="badge bg-success">🏪 Repartidor en tienda</span>}
                    {pedido.estado_bridge === 'EN_RUTA_BRIDGE' && <span className="badge bg-info">🛵 Pedido en ruta</span>}
                    {pedido.estado_bridge === 'EN_UBICACION' && <span className="badge bg-warning text-dark border border-white">📍 ¡En la puerta!</span>}
                    {pedido.estado_bridge === 'ENTREGADO' && <span className="badge bg-dark text-success border border-success">✅ Entregado</span>}
                  </div>
                )}

                {/* BOTÓN CERRAR/ARCHIVAR */}
                {esPedidoCerrable && (
                  <button
                    className="btn btn-sm btn-success"
                    onClick={() => moverPedidoACompletados(pedidoId, pedido.modo_entrega)}
                  >
                    {pedido.modo_entrega === 'retiro' ? '✅ Entregar y Cerrar' : '🗄️ Archivar Pedido'}
                  </button>
                )}

                <button
                  className="btn btn-sm btn-link text-info p-0 text-decoration-none"
                  onClick={() => setPedidoExpandidoId(prev => prev === pedidoId ? null : pedidoId)}
                >
                  {pedidoExpandidoId === pedidoId ? 'Ocultar detalles ▲' : 'Ver detalles ▼'}
                </button>
              </div>
            </div>

            {/* Detalles expandidos (Normalizados) */}
{pedidoExpandidoId === pedidoId && (
  <div className="mt-3 p-3 bg-black bg-opacity-50 border rounded border-secondary">
    <h6>Productos:</h6>
    <ul className="list-group mb-3">
      {(Array.isArray(pedido.productos) ? pedido.productos : []).map((p, i) => (
        <li key={i} className="list-group-item bg-secondary text-white border-dark">
          {p.cantidad} de {p.producto}{p.corte ? ` (${p.corte})` : ''}
        </li>
      ))}
    </ul>

    {/* Usamos datosEnvio que ya procesamos arriba */}
    {Object.keys(datosEnvio).length > 0 && (
      <div className="border-top border-secondary pt-2">
        <h6>Datos de {pedido.modo_entrega === 'retiro' ? 'Contacto' : 'Envío'}:</h6>
        {/* nombreReceptor ya tiene la lógica de elegir el nombre correcto (dueño o receptor) */}
        <p className="mb-1 small"><strong>Recibe:</strong> {nombreReceptor || 'N/A'}</p>
        <p className="mb-1 small"><strong>Dirección:</strong> {datosEnvio.direccion || 'N/A'}</p>
        <p className="mb-1 small"><strong>Teléfono:</strong> {datosEnvio.telefono || 'N/A'}</p>
      </div>
    )}

    <div className="mt-2 text-end border-top border-secondary pt-2">
      <span className="h5 text-warning">Total: ${pedido.precio_final || '0.00'}</span>
    </div>
  </div>
)}

          </li>
        );
      })}
    </ul>
  );
}